/**
 * Announcement Inline Countdown
 * A custom element that displays a countdown timer inline with announcement bar text.
 */
class AnnouncementInlineCountdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.targetDate = this.getTargetDate();
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.endMessageEl = this.querySelector('.countdown-end-message');

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  getTargetDate() {
    const year = parseInt(this.dataset.year, 10);
    const month = parseInt(this.dataset.month, 10) - 1;
    const day = parseInt(this.dataset.day, 10);
    const hour = parseInt(this.dataset.hour, 10) || 0;
    const minute = parseInt(this.dataset.minute, 10) || 0;

    return new Date(year, month, day, hour, minute, 0);
  }

  update() {
    const now = new Date();
    const diff = this.targetDate - now;

    if (diff <= 0) {
      this.handleExpired();
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = this.padNumber(days);
    if (this.hoursEl) this.hoursEl.textContent = this.padNumber(hours);
    if (this.minutesEl) this.minutesEl.textContent = this.padNumber(minutes);
    if (this.secondsEl) this.secondsEl.textContent = this.padNumber(seconds);
  }

  padNumber(num) {
    return num.toString().padStart(2, '0');
  }

  handleExpired() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (this.endMessageEl) {
      // Hide countdown numbers and show end message
      Array.from(this.childNodes).forEach(node => {
        if (node !== this.endMessageEl) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            node.hidden = true;
          } else if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = '';
          }
        }
      });
      this.endMessageEl.hidden = false;
    } else {
      // Just show zeros
      if (this.daysEl) this.daysEl.textContent = '00';
      if (this.hoursEl) this.hoursEl.textContent = '00';
      if (this.minutesEl) this.minutesEl.textContent = '00';
      if (this.secondsEl) this.secondsEl.textContent = '00';
    }
  }
}

customElements.define('announcement-inline-countdown', AnnouncementInlineCountdown);
